import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './store/authStore'
import { Toaster } from 'sonner'

// Layouts
import PublicLayout from './components/layout/PublicLayout'
import DashboardLayout from './components/layout/DashboardLayout'

// ═══════ MARKETING PAGE (remplace HomePage, header intégré, standalone) ═══════
import MarketingPage from './pages/public/MarketingPage'

// Pages publiques (restent dans PublicLayout)
import HomePage from './pages/public/HomePage'
import NewsPage from './pages/public/NewsPage'
import AboutPage from './pages/public/AboutPage'
import LoginPage from './pages/public/LoginPage'

// Pages admin - Dashboard & Modules principaux
import AdminDashboardPage from './pages/admin/AdminDashboardPage'
import DashboardPage from './pages/admin/DashboardPage'
import { StudentsPage } from './pages/admin/StudentsPage'
import TeachersPage from './pages/admin/TeachersPage'
import GradesPage from './pages/admin/GradesPage'
import TimetablePage from './pages/admin/TimetablePage'
import DisciplinePage from './pages/admin/DisciplinePage'
import TeacherDisciplinePage from './pages/admin/discipline/TeacherDisciplinePage'
import APCTrackingPage from './pages/admin/discipline/APCTrackingPage'
import BudgetPage from './pages/admin/BudgetPage'
import ContentPage from './pages/admin/ContentPage'
import AuditPage from './pages/admin/AuditPage'
import SettingsPage from './pages/admin/SettingsPage'
import UsersPage from './pages/admin/Settings/UsersPage'
import FeesPage from './pages/admin/FeesPage'

// ========== PAGES STATISTIQUES MINESEC ==========
import ListProvisoirePage from './pages/admin/statistics/provisoire'
import ListDefinitivePage from './pages/admin/statistics/definitive'
import EffectifsClassesPage from './pages/admin/statistics/effectifs'
import FicheSaisieNotesPage from './pages/admin/statistics/saisie-notes'

// ========== PAGES PROCÈS-VERBAUX (PV) ==========
import PVSequentielPage from './pages/admin/statistics/PVSequentielPage'
import PVTrimestrielPage from './pages/admin/statistics/PVTrimestrielPage'
import PVAnnuelPage from './pages/admin/statistics/PVAnnuelPage'

// ========== TABLEAUX DE BORD PAR MODULE ==========
import StudentsDashboardPage from './pages/admin/dashboards/StudentsDashboardPage'
import TimetableDashboardPage from './pages/admin/dashboards/TimetableDashboardPage'
import GradesDashboardPage from './pages/admin/dashboards/GradesDashboardPage'
import DisciplineDashboardPage from './pages/admin/dashboards/DisciplineDashboardPage'
import AcademicsDashboardPage from './pages/admin/dashboards/AcademicsDashboardPage'
import AdministrationDashboardPage from './pages/admin/dashboards/AdministrationDashboardPage'
import BudgetDashboardPage from './pages/admin/dashboards/BudgetDashboardPage'
import ContentDashboardPage from './pages/admin/dashboards/ContentDashboardPage'
import AuditDashboardPage from './pages/admin/dashboards/AuditDashboardPage'
import MessageDashboardPage from './pages/admin/dashboards/MessageDashboardPage'

// ========== SOUS-MENUS INSCRIPTION DES ÉLÈVES ==========
import StudentSearchPage from './pages/admin/students/StudentSearchPage'
import StudentCreatePage from './pages/admin/students/StudentCreatePage'
import StudentImportPage from './pages/admin/students/StudentImportPage'
import StudentBulkUpdatePage from './pages/admin/students/StudentBulkUpdatePage'
import StudentSocialCasesPage from './pages/admin/students/StudentSocialCasesPage'
import StudentTransferredPage from './pages/admin/students/StudentTransferredPage'
import StudentFormerPage from './pages/admin/students/StudentFormerPage'
import StudentExpelledPage from './pages/admin/students/StudentExpelledPage'

// ========== SOUS-MENUS ACADÉMIQUE ==========
import AcademicSpecialtiesPage from './pages/admin/academics/AcademicSpecialtiesPage'
import AcademicLevelsPage from './pages/admin/academics/AcademicLevelsPage'
import AcademicAssignPage from './pages/admin/academics/AcademicAssignPage'
import AcademicCouncilPage from './pages/admin/academics/AcademicCouncilPage'

// ═══════ NOUVEAUX: Décisions fin d'année + Conseil de classe ═══════
import YearEndDecisionsPage from './pages/admin/academics/YearEndDecisionsPage'
import ClassCouncilAutoPage from './pages/admin/academics/ClassCouncilAutoPage'
import ClassCouncilExpressPage from './pages/admin/academics/ClassCouncilExpressPage'
import ClassCouncilEnrollmentPage from './pages/admin/academics/ClassCouncilEnrollmentPage'

// ========== SOUS-MENUS GRADES / GESTION DES NOTES ==========
import GradesAveragePage from './pages/admin/grades/GradesAveragePage'
import GradesRankingPage from './pages/admin/grades/GradesRankingPage'
import GradesReportCardsPage from './pages/admin/grades/GradesReportCardsPage'
import GradesHonorRollPage from './pages/admin/grades/GradesHonorRollPage'

// Composants
import ProtectedRoute from './components/auth/ProtectedRoute'
import MessagesPage from './pages/admin/MessagesPage'
import CouncilRepeatingPage from './pages/admin/academics/CouncilRepeatingPage'
import CouncilExcludedPage from './pages/admin/academics/CouncilExcludedPage'
import CouncilAdmittedPage from './pages/admin/academics/CouncilAdmittedPage'

import AiAssistantPage from './pages/admin/AiAssistantPage'

import StatisticsNiveauPage from '@/pages/admin/statistics/StatisticsNiveauPage'

/* ═══════════════════════════════════════════════════════════════
   PLACEHOLDERS — Pages en cours de développement
   ═══════════════════════════════════════════════════════════════ */

const Placeholder = ({ title }: { title: string }) => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] text-gray-400">
    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
      <svg className="w-8 h-8 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    </div>
    <h2 className="text-xl font-semibold text-gray-600 mb-1">{title}</h2>
    <p className="text-sm">Page en cours de développement</p>
  </div>
)

const StatisticsDashboardPage = () => <Placeholder title="Statistiques & Rapports" />

const LivretBEPCDECCPage = () => <Placeholder title="Livret BEPC DECC" />
const ListeMajorsPage = () => <Placeholder title="Liste des majors" />
const TauxReussitePage = () => <Placeholder title="Taux de réussite" />
const ListeAdmisPage = () => <Placeholder title="Liste des admis (conseil de classe)" />
const ListeExclusPage = () => <Placeholder title="Liste des exclus (conseil de classe)" />
const ListeRedoublantsPage = () => <Placeholder title="Liste des redoublants (conseil de classe)" />

function App() {
  const { isAuthenticated } = useAuthStore()

  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        {/* ═══════════════════════════════════════════════════════════════
           ROUTE RACINE — MarketingPage (standalone, header intégré)
           ═══════════════════════════════════════════════════════════════ */}
        <Route path="/" element={<MarketingPage />} />

        {/* ==================== ROUTES PUBLIQUES (PublicLayout) ====================
            Pages publiques simplifiées : Actualités + À propos */}
        <Route element={<PublicLayout />}>
          <Route path="/news" element={<NewsPage />} />
          <Route path="/about" element={<AboutPage />} />
          {/* HomePage ancienne conservée sur /home si besoin de fallback */}
          <Route path="/home" element={<HomePage />} />
        </Route>

        {/* ==================== LOGIN ==================== */}
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/admin" replace /> : <LoginPage />}
        />

        {/* ==================== ROUTES PROTÉGÉES (DashboardLayout) ==================== */}
        <Route element={<ProtectedRoute />}>
          <Route path="/admin" element={<AdminDashboardPage />} />

          <Route element={<DashboardLayout />}>
            <Route path="/dashboard" element={<DashboardPage />} />

            {/* ========== MODULES PRINCIPAUX ========== */}
            <Route path="/students" element={<StudentsPage />} />
            <Route path="/teachers" element={<TeachersPage />} />
            <Route path="/grades" element={<GradesPage />} />
            <Route path="/timetable" element={<TimetablePage />} />
            <Route path="/discipline" element={<DisciplinePage />} />
            <Route path="/discipline/students" element={<DisciplinePage />} />
            <Route path="/discipline/teachers" element={<TeacherDisciplinePage />} />
            <Route path="/discipline/apc" element={<APCTrackingPage />} />
            <Route path="/budget" element={<BudgetPage />} />
            <Route path="/content" element={<ContentPage />} />
            <Route path="/audit" element={<AuditPage />} />

            {/* ═══════ MODULE ASSISTANT IA (Ollama local) ═══════ */}
            <Route path="/ai" element={<AiAssistantPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/settings/users" element={<UsersPage />} />

            {/* ========== MODULE SCOLARITÉ (FRAIS) ========== */}
            <Route path="/fees" element={<FeesPage />} />
            <Route path="/fees/types" element={<FeesPage />} />
            <Route path="/fees/structures" element={<FeesPage />} />
            <Route path="/fees/reports" element={<FeesPage />} />

            {/* ========== TABLEAUX DE BORD PAR MODULE ========== */}
            <Route path="/students/dashboard" element={<StudentsDashboardPage />} />
            <Route path="/timetable/dashboard" element={<TimetableDashboardPage />} />
            <Route path="/grades/dashboard" element={<GradesDashboardPage />} />
            <Route path="/discipline/dashboard" element={<DisciplineDashboardPage />} />
            <Route path="/academics/dashboard" element={<AcademicsDashboardPage />} />
            <Route path="/administration/dashboard" element={<AdministrationDashboardPage />} />
            <Route path="/budget/dashboard" element={<BudgetDashboardPage />} />
            <Route path="/content/dashboard" element={<ContentDashboardPage />} />
            <Route path="/audit/dashboard" element={<AuditDashboardPage />} />
            <Route path="/statistics/dashboard" element={<StatisticsDashboardPage />} />

            {/* ═══════ COMMUNICATION / MESSAGES ═══════ */}
            <Route path="/messages/dashboard" element={<MessageDashboardPage />} />
            <Route path="/messages" element={<MessagesPage />} />

            {/* ========== SOUS-MENUS ÉLÈVES ========== */}
            <Route path="/students/search" element={<StudentSearchPage />} />
            <Route path="/students/create" element={<StudentCreatePage />} />
            <Route path="/students/import" element={<StudentImportPage />} />
            <Route path="/students/bulk-update" element={<StudentBulkUpdatePage />} />
            <Route path="/students/social-cases" element={<StudentSocialCasesPage />} />
            <Route path="/students/transferred" element={<StudentTransferredPage />} />
            <Route path="/students/former" element={<StudentFormerPage />} />
            <Route path="/students/expelled" element={<StudentExpelledPage />} />

            {/* ========== SOUS-MENUS ACADÉMIQUE ========== */}
            <Route path="/academics/specialties" element={<AcademicSpecialtiesPage />} />
            <Route path="/academics/levels" element={<AcademicLevelsPage />} />
            <Route path="/academics/assign" element={<AcademicAssignPage />} />
            <Route path="/academics/council" element={<AcademicCouncilPage />} />
            <Route path="/academics/year-end-decisions" element={<YearEndDecisionsPage />} />
            <Route path="/academics/council-auto" element={<ClassCouncilAutoPage />} />
            <Route path="/academics/council-express" element={<ClassCouncilExpressPage />} />
            <Route path="/academics/enrollment" element={<ClassCouncilEnrollmentPage />} />

            {/* ========== SOUS-MENUS GRADES / NOTES ========== */}
            <Route path="/grades/average" element={<GradesAveragePage />} />
            <Route path="/grades/ranking" element={<GradesRankingPage />} />
            <Route path="/grades/bulletins" element={<GradesReportCardsPage />} />
            <Route path="/grades/honor" element={<GradesHonorRollPage />} />

            {/* ═══════ STATISTIQUES & RAPPORTS MINESEC ═══════ */}
            <Route path="/statistics/scolarite/provisoire" element={<ListProvisoirePage />} />
            <Route path="/statistics/scolarite/definitive" element={<ListDefinitivePage />} />
            <Route path="/statistics/scolarite/effectifs" element={<EffectifsClassesPage />} />
            <Route path="/statistics/scolarite/saisie-notes" element={<FicheSaisieNotesPage />} />
            <Route path="/statistics/proces-verbaux/sequentiel" element={<PVSequentielPage />} />
            <Route path="/statistics/proces-verbaux/trimestrielle" element={<PVTrimestrielPage />} />
            <Route path="/statistics/proces-verbaux/annuelle" element={<PVAnnuelPage />} />
            <Route path="/statistics/livret-bepc-decc" element={<LivretBEPCDECCPage />} />
            <Route path="/statistics/majors" element={<ListeMajorsPage />} />
            <Route path="/statistics/taux-reussite" element={<TauxReussitePage />} />
            <Route path="/statistics/admis" element={<ListeAdmisPage />} />
            <Route path="/statistics/exclus" element={<ListeExclusPage />} />
            <Route path="/statistics/redoublants" element={<ListeRedoublantsPage />} />
            <Route path="/statistics/niveau" element={<StatisticsNiveauPage />} />

            <Route path="/council/admitted" element={<CouncilAdmittedPage />} />
            <Route path="/council/excluded" element={<CouncilExcludedPage />} />
            <Route path="/council/repeating" element={<CouncilRepeatingPage />} />
          </Route>
        </Route>

        {/* ==================== REDIRECTIONS ==================== */}
        <Route path="*" element={<Navigate to={isAuthenticated ? "/admin" : "/"} replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App